var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "w-input",
    _vm._b(
      {
        ref: "input",
        staticClass: "f-email",
        on: { input: _vm.input, change: _vm.change },
      },
      "w-input",
      {
        value: _vm.value,
        label: _vm.label,
        required: _vm.required,
        validate: _vm.validate,
      },
      false
    )
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }